import * as React from "react";
import { forwardRef } from "react";
const SvgCharA = (props, ref) => /* @__PURE__ */ React.createElement("svg", { height: "current", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.5 8H9.5M1 11L6 1L11 11", stroke: "current", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCharA);
export default ForwardRef;
